import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  CircularProgress,
} from '@mui/material';
import { useAppSelector } from '../../store/hooks';

interface ViewSettingModalProps {
  open: boolean;
  onClose: () => void;
}

const ViewSettingModal: React.FC<ViewSettingModalProps> = ({ open, onClose }) => {
  const { selectedSetting, loading } = useAppSelector((state) => state.globalSettings);

  if (!selectedSetting && !loading) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Ver Configuración Global</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
            <CircularProgress />
          </Box>
        ) : selectedSetting ? (
          <Box sx={{ mt: 2 }}>
            <TextField
              fullWidth
              label="ID"
              value={selectedSetting.id}
              margin="normal"
              InputProps={{ readOnly: true }}
              variant="filled"
            />
            <TextField
              fullWidth
              label="Clave (Key)"
              value={selectedSetting.settingKey}
              margin="normal"
              InputProps={{ readOnly: true }}
              variant="filled"
            />
            <TextField
              fullWidth
              label="Valor (Value)"
              value={selectedSetting.settingValue}
              margin="normal"
              InputProps={{ readOnly: true }}
              variant="filled"
            />
            <TextField
              fullWidth
              label="Tipo"
              value={selectedSetting.settingType}
              margin="normal"
              InputProps={{ readOnly: true }}
              variant="filled"
            />
            <TextField
              fullWidth
              label="Descripción"
              value={selectedSetting.description}
              margin="normal"
              multiline
              rows={3}
              InputProps={{ readOnly: true }}
              variant="filled"
            />
            <TextField
              fullWidth
              label="Creado el"
              value={selectedSetting.createdAt}
              margin="normal"
              InputProps={{ readOnly: true }}
              variant="filled"
            />
            <TextField
              fullWidth
              label="Creado por"
              value={selectedSetting.createdBy}
              margin="normal"
              InputProps={{ readOnly: true }}
              variant="filled"
            />
          </Box>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewSettingModal;
